import type { Theme } from '../../themes/themes';

export const createIconButtonTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiIconButton: {
      defaultProps: {
        disableFocusRipple: true,
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          borderRadius: theme.spacing(2),
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'transparent',

          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
          '&:focus': {
            color: theme.palette.action.focus,
            borderColor: theme.palette.action.focus,
          },
        },
      },
    },
  },
});
